@if (entity) {
    <div class="card panel-flat-color secondary-panel">
        <div class="panel-flat-header" (click)="expandOrCollapse()" [ngClass]="{ pointer: !editMode }">
            <panel-chevron [showBody]="showBody"></panel-chevron>
            <h3>Client Services</h3>
            @if (showBody) {
                <div class="float-end header-button-container" style="display: flex" (click)="$event.stopPropagation()">
                    @if (isLongRunningProcessRunning) {
                        <div style="padding-right: 15px" class="float-start">
                            <i class="fa fa-info-circle" style="padding-right: 5px"></i>Update in progress
                        </div>
                    }
                    @if (canLaunchHistory) {
                        <button class="ace-btn btn-text has-icon btn-primary" (click)="launchHistoryModal()">
                            <i class="fa fa-history"></i>
                        </button>
                    }
                    @if (canEdit) {
                        <button
                            class="ace-btn btn-text has-icon btn-primary"
                            (click)="goToEditMode()"
                            [disabled]="enteringEditMode"
                        >
                            <i class="fa fa-pencil"></i>
                        </button>
                    }
                    @if (canSave) {
                        <div>
                            @if (isExplicitView) {
                                <button
                                    class="ace-btn btn-text has-icon btn-primary"
                                    (click)="launchHistoryModal()"
                                    [disabled]="serverAction"
                                >
                                    <i class="fa fa-history"></i>
                                </button>
                            }
                            @if (!isLongRunningProcessRunning) {
                                <button
                                    class="ace-btn btn-text has-icon btn-primary btn-success"
                                    (click)="savePanel()"
                                    [disabled]="serverAction"
                                >
                                    <i class="fa fa-save"></i>
                                </button>
                            }
                            <button class="ace-btn btn-text has-icon btn-primary btn-danger" (click)="cancelEdit()">
                                <i class="fa fa-close"></i>
                            </button>
                        </div>
                    }
                </div>
            }
        </div>
        @if (showBody) {
            <div class="card-body">
                @if (serverAction && !panelLoading) {
                    <ws-busy-indicator message="Saving Panel"></ws-busy-indicator>
                }
                @if (panelLoading) {
                    <div style="margin-top: 100px">
                        <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
                    </div>
                }
                @if (!panelLoading && panelData) {
                    <div>
                        <div style="display: flex; justify-content: space-between">
                            <div style="display: flex; gap: 10px; align-items: center">
                                <strong>Account Handler:</strong>
                                @if (!editMode || !isCompany || !isExplicitView) {
                                    <div [ngClass]="{ overridden: isAccountHandlerOverridden }">
                                        {{ accountHandlerTitle }}
                                    </div>
                                }
                                @if (editMode && isCompany && isExplicitView) {
                                    <user-team-picker
                                        style="width: 500px"
                                        [entityTypeScope]="entity.type"
                                        [entityIdScope]="entity.id"
                                        [userId]="panelData.accountHandlerUserID"
                                        [teamId]="panelData.accountHandlerTeamID"
                                        [parentUsers]="ahAvailableUsers"
                                        [fallbackDisplayName]="accountHandlerTitle"
                                        (userChange)="accountHandlerSelected($event)"
                                    >
                                    </user-team-picker>
                                }
                                @if (!isExplicitView && editMode) {
                                    <span>
                                        <i
                                            class="fa fa-info-circle"
                                            title="Changes to Consultant's Account Handler are made from the Manage Consulting Engagements menu"
                                        >
                                        </i>
                                    </span>
                                }
                            </div>

                            @if (!editMode && entity.canEditCompanySetups) {
                                <a
                                    anchor-route
                                    [sref]="{
                                        target: 'csrCommandCenterEntity',
                                        options: { entityId: entity.id, entityTypeId: entity.typeId },
                                    }"
                                    [isTargetBlank]="true"
                                    style="margin-right: 7px"
                                >
                                    Command Center
                                </a>
                            }
                        </div>
                        @if (isEntityInRyanInstance){
                        <div class="row">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center" style="gap: 10px">
                                    <strong>AH Engagement Code:</strong>
                                    <div [ngClass]="{ overridden: panelData.accountHandlerEngagementOverriden }">
                                        {{ accountHandlerEngagement }}
                                    </div>

                                    @if (canEditOtherClientServices && isCompany ) {
                                        @if (isTopLevelCompany) {
                                            <button class="btn btn-sm btn-link p-0"
                                                    (click)="lookupEngagement()"
                                                    tooltip="Select Engagement Number"
                                                    style="line-height: 1"
                                                    >
                                                <i class="fa fa-binoculars"></i>
                                            </button>

                                            @if (panelData.accountHandlerEngagementOverriden) {
                                                <button
                                                    class="btn btn-sm btn-link p-0"
                                                    type="button"
                                                    title="Reset to default engagement code (latest Appeals Real Estate contract term at the Top-Level Company)"
                                                    (click)="resetAhCode()"
                                                    style="line-height: 1; color: red;"
                                                >
                                                    <i class="fa fa-arrow-rotate-left"></i>
                                                </button>
                                            }
                                        }
                                    }

                                    <span class="ms-5">
                                        @if (panelData.engagementContacts?.length) {
                                            @for (contact of engagementContacts; track contact; let isLast = $last) {
                                                <span [style.margin-right]="isLast ? '0' : '25px'">
                                                    <strong>{{ contact.abbr }}:</strong> {{ contact.name }}
                                                </span>
                                            }
                                        }
                                    </span>

                                </div>
                            </div>
                        </div>
                        }

                        <div class="row" style="margin-top: 10px">
                            <div class="col-lg-5">
                                <h4>Responsibilities:</h4>
                            </div>
                            <div class="col-lg-7">
                                <h4>Delivery Details:</h4>
                            </div>
                        </div>
                        @for (service of panelData.entityClientServices; track service) {
                            <div class="card panel-flat-color secondary-panel small-panel" style="margin-bottom: 0">
                                <div class="panel-flat-header small-header">
                                    <h3>{{ service.name }}</h3>
                                </div>
                                <div class="card-body" style="padding: 0 15px">
                                    <div class="row" style="display: flex">
                                        <div
                                            class="col-lg-5"
                                            style="
                                                border-right: 2px solid #c1c9c9;
                                                padding-top: 15px;
                                                padding-bottom: 15px;
                                                white-space: nowrap;
                                            "
                                        >
                                            <!--responsibilities list -->
                                            @for (responsibility of service.responsibilities; track responsibility) {
                                                <div
                                                    style="
                                                        display: flex;
                                                        align-items: center;
                                                        justify-content: space-between;
                                                        margin-bottom: 10px;
                                                    "
                                                >
                                                    <div
                                                        style="
                                                            display: flex;
                                                            align-items: center;
                                                            column-gap: 15px;
                                                            flex-wrap: wrap;
                                                        "
                                                    >
                                                        <!-- property type abbreviation colored square-->
                                                        <div
                                                            class="label property-type-{{
                                                                responsibility.propTypeAbbr
                                                            }}"
                                                            style="font-size: 110%; min-width: 40px"
                                                        >
                                                            {{ responsibility.propTypeAbbr }}
                                                        </div>
                                                        @if (!canEditResponsibility(responsibility)) {
                                                            <div [ngClass]="{ overridden: responsibility.isException }">
                                                                {{
                                                                    responsibility.placeholderText
                                                                        ? responsibility.placeholderText
                                                                        : responsibility.assigneeDisplay
                                                                }}
                                                            </div>
                                                        }
                                                        @if (
                                                            showResponsibilityUpdatingInfoIcon(
                                                                responsibility.clientServiceResponsibilityUpdateStatus
                                                            )
                                                        ) {
                                                            <div
                                                                title="This responsibility is updating in the background.  Changes can't be made until they are finished"
                                                            >
                                                                <i class="fa fa-info-circle"></i>
                                                            </div>
                                                        }
                                                        @if (
                                                            canEditResponsibility(responsibility) &&
                                                            responsibility.disabledWorkflowUserTypes
                                                        ) {
                                                            <select
                                                                class="form-select form-select-sm"
                                                                [ngModel]="responsibility.translatedWorkflowUserTypeId"
                                                                (ngModelChange)="
                                                                    userTypeChanged($event, responsibility)
                                                                "
                                                                style="width: auto"
                                                            >
                                                                @for (type of workflowUserTypes; track type) {
                                                                    @if (showWorkflowUserTypeOption(type.value)) {
                                                                        <option
                                                                            [ngValue]="type.value"
                                                                            [disabled]="
                                                                                responsibility.disabledWorkflowUserTypes.includes(
                                                                                    type.value
                                                                                )
                                                                            "
                                                                        >
                                                                            {{ type.name }}
                                                                        </option>
                                                                    }
                                                                }
                                                            </select>
                                                        }
                                                        <div
                                                            style="display: flex; flex-direction: row; flex-wrap: wrap"
                                                        >
                                                            @if (showSpecificIndividualUserTeamPicker(responsibility)) {
                                                                <user-team-picker
                                                                    style="min-width: 300px; margin-top: 3px"
                                                                    [entityTypeScope]="entity.type"
                                                                    [instanceIdScope]="currentInstanceId"
                                                                    [entityIdScope]="entity.id"
                                                                    [userId]="responsibility.userID"
                                                                    [teamId]="responsibility.teamID"
                                                                    [revertIfEmptyOnBlur]="true"
                                                                    [parentUsers]="csrAvailableUsers"
                                                                    [placeholder]="responsibility.placeholderText"
                                                                    (userChange)="
                                                                        specificIndividualSelected(
                                                                            $event,
                                                                            responsibility
                                                                        )
                                                                    "
                                                                >
                                                                </user-team-picker>
                                                            }
                                                            <!--calendar-->
                                                            @if (
                                                                canEditResponsibility(responsibility) &&
                                                                responsibility.showDatePicker
                                                            ) {
                                                                <div
                                                                    style="
                                                                        display: flex;
                                                                        align-items: center;
                                                                        gap: 5px;
                                                                        margin: 3px 0 0 8px;
                                                                    "
                                                                >
                                                                    <label>From Date:</label>
                                                                    <weissman-datetime
                                                                        [(inputDate)]="responsibility.dateFrom"
                                                                        [dateOnly]="true"
                                                                    ></weissman-datetime>
                                                                </div>
                                                            }
                                                        </div>
                                                        <!-- consulting engagements -->
                                                        @if (showConsultingEngagementsList(responsibility)) {
                                                            <div>
                                                                @if (consultingEngagements.length === 1) {
                                                                    <div> - {{ consultingEngagements[0].name }}</div>
                                                                }
                                                                @if (consultingEngagements.length > 1) {
                                                                    <select
                                                                        class="form-select form-select-sm"
                                                                        style="width: auto"
                                                                        [(ngModel)]="
                                                                            responsibility.consultingEngagementId
                                                                        "
                                                                        (change)="
                                                                            changeConsultingEngagement(responsibility)
                                                                        "
                                                                    >
                                                                        @for (
                                                                            consultingEngagement of consultingEngagements;
                                                                            track consultingEngagement
                                                                        ) {
                                                                            <option
                                                                                [ngValue]="
                                                                                    consultingEngagement.consultingEngagementId
                                                                                "
                                                                            >
                                                                                {{ consultingEngagement.name }}
                                                                            </option>
                                                                        }
                                                                    </select>
                                                                }
                                                            </div>
                                                        }
                                                        @if (
                                                            showRetryResponsibilityUpdateIcon(
                                                                responsibility.clientServiceResponsibilityUpdateStatus
                                                            )
                                                        ) {
                                                            <button
                                                                class="ace-btn has-icon"
                                                                style="top: 5px"
                                                                (click)="retryResponsibilityUpdate(responsibility)"
                                                                title="This responsibility didn't update correctly.  Push this button to retry the updates.  Some changes can't be made until the updates succeed."
                                                            >
                                                                <i class="fa fa-repeat"></i>
                                                            </button>
                                                        }
                                                    </div>
                                                    <!--Exceptions link-->
                                                    @if (
                                                        showExceptionsLink(
                                                            responsibility.clientServiceResponsibilityUpdateStatus
                                                        )
                                                    ) {
                                                        <div>
                                                            @if (responsibility.customerHasChildExceptions) {
                                                                <span
                                                                    class="anchor-style"
                                                                    (click)="
                                                                        openExceptionsModal(responsibility, service)
                                                                    "
                                                                >
                                                                    Exceptions
                                                                </span>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div class="col-lg-7" style="padding-top: 15px; padding-bottom: 15px">
                                            @if (
                                                service.clientServiceID === ClientServiceType.ComplianceReturns &&
                                                hasComplianceFeatureView &&
                                                entity.isTopLevel
                                            ) {
                                                <delivery-details-compliance-returns
                                                    [editMode]="canEditOtherClientServices && isCompany && !isLicensedDIUser"
                                                    [entity]="entity"
                                                    [(currentData)]="service.deliveryDetailPPReturnBatchCurrent"
                                                    [service]="service"
                                                    [ces]="consultingEngagements"
                                                    [entityInstanceId]="entityInstanceId"
                                                    [isConsultantPerspective]="isConsultantPerspective"
                                                    [userSearchInstanceId]="currentInstanceId"
                                                >
                                                </delivery-details-compliance-returns>
                                            }
                                            @if (
                                                service.clientServiceID === ClientServiceType.ComplianceReturns &&
                                                hasComplianceFeatureView &&
                                                !entity.isTopLevel
                                            ) {
                                                <delivery-details-compliance-returns
                                                    [editMode]="canEditOtherClientServices && isCompany && !isConsultantPerspective"
                                                    [entity]="entity"
                                                    [(currentData)]="service.deliveryDetailPPReturnBatchTop"
                                                    [service]="service"
                                                    [ces]="consultingEngagements"
                                                    [entityInstanceId]="entityInstanceId"
                                                    [isConsultantPerspective]="isConsultantPerspective"
                                                    [userSearchInstanceId]="currentInstanceId"
                                                >
                                                </delivery-details-compliance-returns>
                                            }
                                            @if (service.clientServiceID === ClientServiceType.Assessments) {
                                                <delivery-details-team-retrieves
                                                    [editMode]="
                                                        canEditOtherClientServices && (!isConsultantPerspective || isLicensedDIUser)
                                                    "
                                                    [(currentData)]="service.deliveryDetailAssessmentCurrent"
                                                    [topLevelData]="service.deliveryDetailAssessmentTop"
                                                    [entity]="entity"
                                                    [(taxFeedIsEnabled)]="taxFeedSettings.assessmentsTaxFeedsEnabled"
                                                    [taxFeedEnablingMessage]="
                                                        isParcel
                                                            ? 'Parcel assessments will be updated via PTX tax feed.'
                                                            : 'All company parcel assessments will be updated via PTX tax feed.'
                                                    "
                                                    [taxFeedDisablingMessage]="
                                                        isParcel
                                                            ? 'Parcel assessments will not be updated via PTX tax feed.'
                                                            : 'All company parcel assessments will not be updated via PTX tax feed.'
                                                    "
                                                    [taxFeedToggleEnabled]="
                                                        isTaxFeedToggleEnabled(
                                                            topLevelCompanyTaxFeedSettings?.assessmentsTaxFeedsEnabled
                                                        )
                                                    "
                                                    [taxFeedToggleVisible]="isTopLevelCompany || isParcel"
                                                    [isEntityInRyanInstance]="
                                                        isEntityInRyanInstance || isLicensedDIUser
                                                    "
                                                >
                                                </delivery-details-team-retrieves>
                                            }
                                            @if (service.clientServiceID === ClientServiceType.TaxBills) {
                                                <delivery-details-team-retrieves
                                                    [editMode]="
                                                        canEditOtherClientServices && (!isConsultantPerspective || isLicensedDIUser)
                                                    "
                                                    [(currentData)]="service.deliveryDetailBillCurrent"
                                                    [topLevelData]="service.deliveryDetailBillTop"
                                                    [entity]="entity"
                                                    [(taxFeedIsEnabled)]="taxFeedSettings.taxBillsTaxFeedsEnabled"
                                                    [taxFeedEnablingMessage]="
                                                        isParcel
                                                            ? 'Parcel tax bills will be updated via PTX tax feed.'
                                                            : 'All company parcel tax bills will be updated via PTX tax feed.'
                                                    "
                                                    [taxFeedDisablingMessage]="
                                                        isParcel
                                                            ? 'Parcel tax bills will not be updated via PTX tax feed.'
                                                            : 'All company parcel tax bills will not be updated via PTX tax feed.'
                                                    "
                                                    [taxFeedToggleEnabled]="
                                                        isTaxFeedToggleEnabled(
                                                            topLevelCompanyTaxFeedSettings?.taxBillsTaxFeedsEnabled
                                                        )
                                                    "
                                                    [taxFeedToggleVisible]="isTopLevelCompany || isParcel"
                                                    [isEntityInRyanInstance]="
                                                        isEntityInRyanInstance || isLicensedDIUser
                                                    "
                                                >
                                                </delivery-details-team-retrieves>
                                            }
                                            @if (service.clientServiceID === ClientServiceType.TaxBillTransmit) {
                                                <delivery-details-transmit
                                                    [currentData]="service.taxBillDeliveryDetailsCurrent"
                                                    [topLevelData]="service.taxBillDeliveryDetailsTop"
                                                    [editMode]="
                                                        canEditOtherClientServices && !isConsultantPerspective && !isLicensedDIUser
                                                    "
                                                    [userSearchInstanceId]="currentInstanceId"
                                                    [isEntityInRyanInstance]="isEntityInRyanInstance"
                                                    (currentPaymentBatchDataChange)="paymentBatchData = $event"
                                                    [entity]="entity"
                                                >
                                                </delivery-details-transmit>
                                            }
                                            @if (service.clientServiceID === ClientServiceType.Allocation) {
                                                <delivery-details-assessment-allocation
                                                    [(currentData)]="service.deliveryDetailAssessmentAllocationTop"
                                                    [editMode]="canEditOtherClientServices && !isConsultantPerspective"
                                                    [entity]="entity"
                                                    [ces]="consultingEngagements"
                                                    [service]="service"
                                                    [entityInstanceId]="entityInstanceId"
                                                    [isConsultantPerspective]="isConsultantPerspective"
                                                    [userSearchInstanceId]="currentInstanceId"
                                                >
                                                </delivery-details-assessment-allocation>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        @if (isTopLevelCompany && canEditOtherClientServices && isExplicitView) {
                            <div style="margin-top: 15px; display: flex; gap: 15px">
                                <ws-select
                                    placeholder="Add Service"
                                    [(ngModel)]="newClientService"
                                    [isLoading]="loadingDropdownData"
                                    (selectedOptionChanged)="addClientService()"
                                    [options]="availableClientServices"
                                    labelProperty="name"
                                    [returnEntireOption]="true"
                                    searchType="substring"
                                >
                                </ws-select>
                                <ws-select
                                    placeholder="Add Property Type"
                                    [(ngModel)]="newPropertyType"
                                    [isLoading]="loadingDropdownData"
                                    (selectedOptionChanged)="addPropertyType()"
                                    [options]="availablePropertyTypes"
                                    labelProperty="propTypeName"
                                    [returnEntireOption]="true"
                                    searchType="substring"
                                >
                                </ws-select>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
